import React, { useContext, useEffect } from "react";
import { useRouter } from "next/router";

import { ModalContext } from "@/contexts/ModalsContext";

import VhInfo from "@/components/Vehicle.component";
import GenArtBar from "@/components/GenartBar.component";
import Notification from "@/components/Notification.component";
// import Notice from "@/components/Notice.component";

import AuthenticateAdmin from "@/middlewares/AuthAdmin";

import Footer from "./Footer";
import Header from "./Header";
import NavBar from "./NavBar";

import CookiesModal from "@/modals/Cookies.modal";

const Layout = ({children}: any) => {
    const { modalState: { consent }, dispatchModal } = useContext(ModalContext);
    const { authAdmin } = AuthenticateAdmin();
    const router = useRouter();

    useEffect(() => {
        if (localStorage.getItem("__gaat")) {
            authAdmin();
        }
        
        if (!localStorage.getItem("_usc")) {
            localStorage.setItem("_consent", "unconfirmed");
        }

        if (localStorage.getItem("_consent")) {
            getConsent(localStorage.getItem("_consent")!);
        } else {
            localStorage.removeItem("_usc");
            dispatchModal({type: "SET_CONSENT"});
        }
    }, []);

    const getConsent = (cnst: string) => {
        if (cnst === "unconfirmed" && !consent) {
            localStorage.removeItem("_usc");
            dispatchModal({type: "SET_CONSENT"});
        }
    };

    return (
        <React.Fragment>
            <Header />
            <NavBar />
            {/* <Notice /> */}
            {/* <GenArtBar /> */}

            {router.pathname !== "/cart" && <GenArtBar />}
            {router.pathname !== "/cart" && <VhInfo />}

            <main>
                {children}
            </main>
            {consent && <CookiesModal />}

            <Notification timeout={3000} />

            <Footer />
        </React.Fragment>
    );
}

export default Layout;
